import { CompanyDto } from './company-dto.model';
import { LocationDto } from './location-dto.model';
import { BranchDto } from './branch-dto.model';
import { DepartmentDto } from './department-dto.model';
import { DesignationDto } from './designation-dto.model';
import { RoleDto } from './role-dto.model';
import { ShiftGroupDto } from './shift-group-dto.model';
import { PaymentTypeDto } from './payment-type-dto.model';
import { BankDto } from './bank-dto.model';
import { EmployeeIncrementDto } from './employee-increment-dto.model';
import { UserDto } from './user-dto.model';
import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { EmployeeDocumentDto } from './employee-document-dto.model';
import { EmployeeRelationDto } from './employee-relation-dto.model';
import { SalaryStructureDto } from './salary-structure-dto.model';
import { EmployeeType,VehicleType } from '../service-proxies';


export class EmployeeDto implements IEmployeeDto {
    id!: number;
    company!: CompanyDto;
    location!: LocationDto;
    empCode!: number;
    empName!: string | undefined;
    mobileNo!: string | undefined;
    branch!: BranchDto;
    department!: DepartmentDto;
    designation!: DesignationDto;
    role!: RoleDto;
    birthDate!: Date;
    gender!: string | undefined;
    profileImageUrl!: string | undefined;
    isActive!: boolean;
    shift!: ShiftGroupDto;
    fatherName!: string | undefined;
    motherName!: string | undefined;
    spouseName!: string | undefined;
    secondContactNo!: string | undefined;
    email!: string | undefined;
    education!: string | undefined;
    aadharNo!: string | undefined;
    pan!: string | undefined;
    paymentType!: PaymentTypeDto;
    address!: string | undefined;
    pincode!: string | undefined;
    bank!: BankDto;
    bankAccNo!: string | undefined;
    ifscCode!: string | undefined;
    secondaryBankAccNo!: string | undefined;
    secondaryIFSCCode!: string | undefined;
    secondaryBankAccName!: string | undefined;
    seconadryBankId!: number | undefined;
    additionalSalary!: number;
    tdsDeductable!: boolean;
    basicSalary!: number;
    ptDeductable!: boolean;
    employeeIncrement!: EmployeeIncrementDto[] | undefined;
    joinDate!: Date;
    traineeJoinDate!: Date | undefined;
    isTrainee!: boolean;
    resignDate!: Date | undefined;
    previousCompanyDetail!: string | undefined;
    notes!: string | undefined;
    nextIncrementDate!: Date | undefined;
    referenceDetail!: string | undefined;
    user!: UserDto;
    isAgreement!: boolean;
    longitude!: number;
    latitude!: number;
    useEmployeeLocation!: boolean;
    fixedSalary!: boolean;
    useWFHEmployeeLocation!: boolean;
    employeeLeader!: EmployeeSummaryDto;
    employeeType!: EmployeeType;
    empLegalName!: string | undefined;
    employeeDocuments!: EmployeeDocumentDto[] | undefined;
    isFuelAllownace!: boolean;
    vehicleTypeId!: VehicleType;
    vehicleTypeName!: string | undefined;
    pfNo!: string | undefined;
    pfuan!: string | undefined;
    esicNo!: string | undefined;
    maritalStatus!: string | undefined;
    anniversaryDate!: Date | undefined;
    currentDistrict!: string | undefined;
    currentState!: string | undefined;
    permanentAddress!: string | undefined;
    permanentPincode!: string | undefined;
    permanentDistrict!: string | undefined;
    permanentState!: string | undefined;
    employeeRelations!: EmployeeRelationDto[] | undefined;
    salaryStructure!: SalaryStructureDto;
    basicAlw!: number;
    dearnessAlw!: number;
    houseRentAlw!: number;
    medicalAlw!: number;
    dailyTravellingAlw!: number;
    performanceAlw!: number;
    otherAlw!: number;
    productionAlw!: number;
    fuelAlw!: number;
    pfDetectable!: boolean;
    esicDetectable!: boolean;
    lwfDetectable!: boolean;
    isOnContract!: boolean;
    contractEndDate!: Date | undefined;
    isAttendanceCalc!: boolean;
    referenceEmployeeId!: number | undefined;
    referralBonusDate!: Date | undefined;
    referralBonusPaid!: boolean;
    joinTimeExperience!: string | undefined;
    educationId!: number | undefined;
    resignCreatedDate!: Date | undefined;
    noticePeriodEndDate!: Date | undefined;
    isLeave!: boolean;
    isJoin!: boolean;
    employeeTotalExperience!: string | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : <any>undefined;
            this.empCode = _data["empCode"];
            this.empName = _data["empName"];
            this.mobileNo = _data["mobileNo"];
            this.branch = _data["branch"] ? BranchDto.fromJS(_data["branch"]) : <any>undefined;
            this.department = _data["department"] ? DepartmentDto.fromJS(_data["department"]) : <any>undefined;
            this.designation = _data["designation"] ? DesignationDto.fromJS(_data["designation"]) : <any>undefined;
            this.role = _data["role"] ? RoleDto.fromJS(_data["role"]) : <any>undefined;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>undefined;
            this.gender = _data["gender"];
            this.profileImageUrl = _data["profileImageUrl"];
            this.isActive = _data["isActive"];
            this.shift = _data["shift"] ? ShiftGroupDto.fromJS(_data["shift"]) : <any>undefined;
            this.fatherName = _data["fatherName"];
            this.motherName = _data["motherName"];
            this.spouseName = _data["spouseName"];
            this.secondContactNo = _data["secondContactNo"];
            this.email = _data["email"];
            this.education = _data["education"];
            this.aadharNo = _data["aadharNo"];
            this.pan = _data["pan"];
            this.paymentType = _data["paymentType"] ? PaymentTypeDto.fromJS(_data["paymentType"]) : <any>undefined;
            this.address = _data["address"];
            this.pincode = _data["pincode"];
            this.bank = _data["bank"] ? BankDto.fromJS(_data["bank"]) : <any>undefined;
            this.bankAccNo = _data["bankAccNo"];
            this.ifscCode = _data["ifscCode"];
            this.secondaryBankAccNo = _data["secondaryBankAccNo"];
            this.secondaryIFSCCode = _data["secondaryIFSCCode"];
            this.secondaryBankAccName = _data["secondaryBankAccName"];
            this.seconadryBankId = _data["seconadryBankId"];
            this.additionalSalary = _data["additionalSalary"];
            this.tdsDeductable = _data["tdsDeductable"];
            this.basicSalary = _data["basicSalary"];
            this.ptDeductable = _data["ptDeductable"];
            if (Array.isArray(_data["employeeIncrement"])) {
                this.employeeIncrement = [] as any;
                for (let item of _data["employeeIncrement"])
                    this.employeeIncrement!.push(EmployeeIncrementDto.fromJS(item));
            }
            this.joinDate = _data["joinDate"] ? new Date(_data["joinDate"].toString()) : <any>undefined;
            this.traineeJoinDate = _data["traineeJoinDate"] ? new Date(_data["traineeJoinDate"].toString()) : <any>undefined;
            this.isTrainee = _data["isTrainee"];
            this.resignDate = _data["resignDate"] ? new Date(_data["resignDate"].toString()) : <any>undefined;
            this.previousCompanyDetail = _data["previousCompanyDetail"];
            this.notes = _data["notes"];
            this.nextIncrementDate = _data["nextIncrementDate"] ? new Date(_data["nextIncrementDate"].toString()) : <any>undefined;
            this.referenceDetail = _data["referenceDetail"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.isAgreement = _data["isAgreement"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.useEmployeeLocation = _data["useEmployeeLocation"];
            this.fixedSalary = _data["fixedSalary"];
            this.useWFHEmployeeLocation = _data["useWFHEmployeeLocation"];
            this.employeeLeader = _data["employeeLeader"] ? EmployeeSummaryDto.fromJS(_data["employeeLeader"]) : <any>undefined;
            this.employeeType = _data["employeeType"];
            this.empLegalName = _data["empLegalName"];
            if (Array.isArray(_data["employeeDocuments"])) {
                this.employeeDocuments = [] as any;
                for (let item of _data["employeeDocuments"])
                    this.employeeDocuments!.push(EmployeeDocumentDto.fromJS(item));
            }
            this.isFuelAllownace = _data["isFuelAllownace"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.vehicleTypeName = _data["vehicleTypeName"];
            this.pfNo = _data["pfNo"];
            this.pfuan = _data["pfuan"];
            this.esicNo = _data["esicNo"];
            this.maritalStatus = _data["maritalStatus"];
            this.anniversaryDate = _data["anniversaryDate"] ? new Date(_data["anniversaryDate"].toString()) : <any>undefined;
            this.currentDistrict = _data["currentDistrict"];
            this.currentState = _data["currentState"];
            this.permanentAddress = _data["permanentAddress"];
            this.permanentPincode = _data["permanentPincode"];
            this.permanentDistrict = _data["permanentDistrict"];
            this.permanentState = _data["permanentState"];
            if (Array.isArray(_data["employeeRelations"])) {
                this.employeeRelations = [] as any;
                for (let item of _data["employeeRelations"])
                    this.employeeRelations!.push(EmployeeRelationDto.fromJS(item));
            }
            this.salaryStructure = _data["salaryStructure"] ? SalaryStructureDto.fromJS(_data["salaryStructure"]) : <any>undefined;
            this.basicAlw = _data["basicAlw"];
            this.dearnessAlw = _data["dearnessAlw"];
            this.houseRentAlw = _data["houseRentAlw"];
            this.medicalAlw = _data["medicalAlw"];
            this.dailyTravellingAlw = _data["dailyTravellingAlw"];
            this.performanceAlw = _data["performanceAlw"];
            this.otherAlw = _data["otherAlw"];
            this.productionAlw = _data["productionAlw"];
            this.fuelAlw = _data["fuelAlw"];
            this.pfDetectable = _data["pfDetectable"];
            this.esicDetectable = _data["esicDetectable"];
            this.lwfDetectable = _data["lwfDetectable"];
            this.isOnContract = _data["isOnContract"];
            this.contractEndDate = _data["contractEndDate"] ? new Date(_data["contractEndDate"].toString()) : <any>undefined;
            this.isAttendanceCalc = _data["isAttendanceCalc"];
            this.referenceEmployeeId = _data["referenceEmployeeId"];
            this.referralBonusDate = _data["referralBonusDate"] ? new Date(_data["referralBonusDate"].toString()) : <any>undefined;
            this.referralBonusPaid = _data["referralBonusPaid"];
            this.joinTimeExperience = _data["joinTimeExperience"];
            this.educationId = _data["educationId"];
            this.resignCreatedDate = _data["resignCreatedDate"] ? new Date(_data["resignCreatedDate"].toString()) : <any>undefined;
            this.noticePeriodEndDate = _data["noticePeriodEndDate"] ? new Date(_data["noticePeriodEndDate"].toString()) : <any>undefined;
            this.isLeave = _data["isLeave"];
            this.isJoin = _data["isJoin"];
            this.employeeTotalExperience = _data["employeeTotalExperience"];
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["empCode"] = this.empCode;
        data["empName"] = this.empName;
        data["mobileNo"] = this.mobileNo;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["designation"] = this.designation ? this.designation.toJSON() : <any>undefined;
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["gender"] = this.gender;
        data["profileImageUrl"] = this.profileImageUrl;
        data["isActive"] = this.isActive;
        data["shift"] = this.shift ? this.shift.toJSON() : <any>undefined;
        data["fatherName"] = this.fatherName;
        data["motherName"] = this.motherName;
        data["spouseName"] = this.spouseName;
        data["secondContactNo"] = this.secondContactNo;
        data["email"] = this.email;
        data["education"] = this.education;
        data["aadharNo"] = this.aadharNo;
        data["pan"] = this.pan;
        data["paymentType"] = this.paymentType ? this.paymentType.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["pincode"] = this.pincode;
        data["bank"] = this.bank ? this.bank.toJSON() : <any>undefined;
        data["bankAccNo"] = this.bankAccNo;
        data["ifscCode"] = this.ifscCode;
        data["secondaryBankAccNo"] = this.secondaryBankAccNo;
        data["secondaryIFSCCode"] = this.secondaryIFSCCode;
        data["secondaryBankAccName"] = this.secondaryBankAccName;
        data["seconadryBankId"] = this.seconadryBankId;
        data["additionalSalary"] = this.additionalSalary;
        data["tdsDeductable"] = this.tdsDeductable;
        data["basicSalary"] = this.basicSalary;
        data["ptDeductable"] = this.ptDeductable;
        if (Array.isArray(this.employeeIncrement)) {
            data["employeeIncrement"] = [];
            for (let item of this.employeeIncrement)
                data["employeeIncrement"].push(item.toJSON());
        }
        data["joinDate"] = this.joinDate ? this.joinDate.toISOString() : <any>undefined;
        data["traineeJoinDate"] = this.traineeJoinDate ? this.traineeJoinDate.toISOString() : <any>undefined;
        data["isTrainee"] = this.isTrainee;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        data["previousCompanyDetail"] = this.previousCompanyDetail;
        data["notes"] = this.notes;
        data["nextIncrementDate"] = this.nextIncrementDate ? this.nextIncrementDate.toISOString() : <any>undefined;
        data["referenceDetail"] = this.referenceDetail;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["isAgreement"] = this.isAgreement;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["useEmployeeLocation"] = this.useEmployeeLocation;
        data["fixedSalary"] = this.fixedSalary;
        data["useWFHEmployeeLocation"] = this.useWFHEmployeeLocation;
        data["employeeLeader"] = this.employeeLeader ? this.employeeLeader.toJSON() : <any>undefined;
        data["employeeType"] = this.employeeType;
        data["empLegalName"] = this.empLegalName;
        if (Array.isArray(this.employeeDocuments)) {
            data["employeeDocuments"] = [];
            for (let item of this.employeeDocuments)
                data["employeeDocuments"].push(item.toJSON());
        }
        data["isFuelAllownace"] = this.isFuelAllownace;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["vehicleTypeName"] = this.vehicleTypeName;
        data["pfNo"] = this.pfNo;
        data["pfuan"] = this.pfuan;
        data["esicNo"] = this.esicNo;
        data["maritalStatus"] = this.maritalStatus;
        data["anniversaryDate"] = this.anniversaryDate ? this.anniversaryDate.toISOString() : <any>undefined;
        data["currentDistrict"] = this.currentDistrict;
        data["currentState"] = this.currentState;
        data["permanentAddress"] = this.permanentAddress;
        data["permanentPincode"] = this.permanentPincode;
        data["permanentDistrict"] = this.permanentDistrict;
        data["permanentState"] = this.permanentState;
        if (Array.isArray(this.employeeRelations)) {
            data["employeeRelations"] = [];
            for (let item of this.employeeRelations)
                data["employeeRelations"].push(item.toJSON());
        }
        data["salaryStructure"] = this.salaryStructure ? this.salaryStructure.toJSON() : <any>undefined;
        data["basicAlw"] = this.basicAlw;
        data["dearnessAlw"] = this.dearnessAlw;
        data["houseRentAlw"] = this.houseRentAlw;
        data["medicalAlw"] = this.medicalAlw;
        data["dailyTravellingAlw"] = this.dailyTravellingAlw;
        data["performanceAlw"] = this.performanceAlw;
        data["otherAlw"] = this.otherAlw;
        data["productionAlw"] = this.productionAlw;
        data["fuelAlw"] = this.fuelAlw;
        data["pfDetectable"] = this.pfDetectable;
        data["esicDetectable"] = this.esicDetectable;
        data["lwfDetectable"] = this.lwfDetectable;
        data["isOnContract"] = this.isOnContract;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : <any>undefined;
        data["isAttendanceCalc"] = this.isAttendanceCalc;
        data["referenceEmployeeId"] = this.referenceEmployeeId;
        data["referralBonusDate"] = this.referralBonusDate ? this.referralBonusDate.toISOString() : <any>undefined;
        data["referralBonusPaid"] = this.referralBonusPaid;
        data["joinTimeExperience"] = this.joinTimeExperience;
        data["educationId"] = this.educationId;
        data["resignCreatedDate"] = this.resignCreatedDate ? this.resignCreatedDate.toISOString() : <any>undefined;
        data["noticePeriodEndDate"] = this.noticePeriodEndDate ? this.noticePeriodEndDate.toISOString() : <any>undefined;
        data["isLeave"] = this.isLeave;
        data["isJoin"] = this.isJoin;
        data["employeeTotalExperience"] = this.employeeTotalExperience;
        return data; 
    }
}

export interface IEmployeeDto {
    id: number;
    company: CompanyDto;
    location: LocationDto;
    empCode: number;
    empName: string | undefined;
    mobileNo: string | undefined;
    branch: BranchDto;
    department: DepartmentDto;
    designation: DesignationDto;
    role: RoleDto;
    birthDate: Date;
    gender: string | undefined;
    profileImageUrl: string | undefined;
    isActive: boolean;
    shift: ShiftGroupDto;
    fatherName: string | undefined;
    motherName: string | undefined;
    spouseName: string | undefined;
    secondContactNo: string | undefined;
    email: string | undefined;
    education: string | undefined;
    aadharNo: string | undefined;
    pan: string | undefined;
    paymentType: PaymentTypeDto;
    address: string | undefined;
    pincode: string | undefined;
    bank: BankDto;
    bankAccNo: string | undefined;
    ifscCode: string | undefined;
    secondaryBankAccNo: string | undefined;
    secondaryIFSCCode: string | undefined;
    secondaryBankAccName: string | undefined;
    seconadryBankId: number | undefined;
    additionalSalary: number;
    tdsDeductable: boolean;
    basicSalary: number;
    ptDeductable: boolean;
    employeeIncrement: EmployeeIncrementDto[] | undefined;
    joinDate: Date;
    traineeJoinDate: Date | undefined;
    isTrainee: boolean;
    resignDate: Date | undefined;
    previousCompanyDetail: string | undefined;
    notes: string | undefined;
    nextIncrementDate: Date | undefined;
    referenceDetail: string | undefined;
    user: UserDto;
    isAgreement: boolean;
    longitude: number;
    latitude: number;
    useEmployeeLocation: boolean;
    fixedSalary: boolean;
    useWFHEmployeeLocation: boolean;
    employeeLeader: EmployeeSummaryDto;
    employeeType: EmployeeType;
    empLegalName: string | undefined;
    employeeDocuments: EmployeeDocumentDto[] | undefined;
    isFuelAllownace: boolean;
    vehicleTypeId: VehicleType;
    vehicleTypeName: string | undefined;
    pfNo: string | undefined;
    pfuan: string | undefined;
    esicNo: string | undefined;
    maritalStatus: string | undefined;
    anniversaryDate: Date | undefined;
    currentDistrict: string | undefined;
    currentState: string | undefined;
    permanentAddress: string | undefined;
    permanentPincode: string | undefined;
    permanentDistrict: string | undefined;
    permanentState: string | undefined;
    employeeRelations: EmployeeRelationDto[] | undefined;
    salaryStructure: SalaryStructureDto;
    basicAlw: number;
    dearnessAlw: number;
    houseRentAlw: number;
    medicalAlw: number;
    dailyTravellingAlw: number;
    performanceAlw: number;
    otherAlw: number;
    productionAlw: number;
    fuelAlw: number;
    pfDetectable: boolean;
    esicDetectable: boolean;
    lwfDetectable: boolean;
    isOnContract: boolean;
    contractEndDate: Date | undefined;
    isAttendanceCalc: boolean;
    referenceEmployeeId: number | undefined;
    referralBonusDate: Date | undefined;
    referralBonusPaid: boolean;
    joinTimeExperience: string | undefined;
    educationId: number | undefined;
    resignCreatedDate: Date | undefined;
    noticePeriodEndDate: Date | undefined;
    isLeave: boolean;
    isJoin: boolean;
    employeeTotalExperience: string | undefined;
}

